module.exports = __webpack_public_path__ + "media/images/smart_phone/still_sp-97cebe3ad0e7032dc57d44ebbc6f9b69.gif";